export var cos = Math.cos;
export var sin = Math.sin;
export var pi = Math.PI;
export var halfPi = pi / 2;
export var tau = pi * 2;
export var max = Math.max;



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-chord/src/math.js
// module id = 113
// module chunks = 0 1 2 3 4